import type { CardType } from "./types";

export const CardSubtypes: Record<CardType, Record<string, string>> = {
	action: {
		none: "card.subtype.none",
		attack: "card.subtype.attack",
		ally: "card.subtype.ally",
		arrow_attack: "card.subtype.arrow_attack",
		dagger_attack: "card.subtype.dagger_attack",
		aura: "card.subtype.aura",
		affliction_aura: "card.subtype.affliction_aura",
		construct: "card.subtype.construct",
		invocation: "card.subtype.invocation",
		item: "card.subtype.item",
		shuriken_item: "card.subtype.shuriken_item",
		cog_item: "card.subtype.cog_item",
		landmark: "card.subtype.landmark",
		song: "card.subtype.song",
	},
	attack_reaction: {
		none: "card.subtype.none",
	},
	block: {
		none: "card.subtype.none",
	},
	defense_reaction: {
		none: "card.subtype.none",
		trap: "card.subtype.trap",
	},
	demi_hero: {
		none: "card.subtype.none",
		demon: "card.subtype.demon",
		young: "card.subtype.young",
	},
	equipment: {
		none: "card.subtype.none",
		head: "card.subtype.head",
		chest: "card.subtype.chest",
		arms: "card.subtype.arms",
		legs: "card.subtype.legs",
		base: "card.subtype.base",
		base_head: "card.subtype.base_head",
		base_chest: "card.subtype.base_chest",
		base_arms: "card.subtype.base_arms",
		base_legs: "card.subtype.base_legs",
		off_hand: "card.subtype.off_hand",
		item: "card.subtype.item",
	},
	hero: {
		none: "card.subtype.none",
		demon: "card.subtype.demon",
		young: "card.subtype.young",
	},
	instant: {
		none: "card.subtype.none",
		aura: "card.subtype.aura",
		figment: "card.subtype.figment",
		trap: "card.subtype.trap",
	},
	macro: {
		none: "card.subtype.none",
	},
	mentor: {
		none: "card.subtype.none",
	},
	resource: {
		none: "card.subtype.none",
		gem: "card.subtype.gem",
		chi: "card.subtype.chi",
	},
	token: {
		none: "card.subtype.none",
	},
	weapon: {
		none: "card.subtype.none",
		axe: "card.subtype.axe",
		book: "card.subtype.book",
		bow: "card.subtype.bow",
		brush: "card.subtype.brush",
		club: "card.subtype.club",
		dagger: "card.subtype.dagger",
		fiddle: "card.subtype.fiddle",
		flail: "card.subtype.flail",
		gun: "card.subtype.gun",
		hammer: "card.subtype.hammer",
		lute: "card.subtype.lute",
		orb: "card.subtype.orb",
		pistol: "card.subtype.pistol",
		polearm: "card.subtype.polearm",
		rock: "card.subtype.rock",
		scepter: "card.subtype.scepter",
		scroll: "card.subtype.scroll",
		scythe: "card.subtype.scythe",
		staff: "card.subtype.staff",
		sword: "card.subtype.sword",
		wrench: "card.subtype.wrench",
	},
	weapon_equipment: {
		none: "card.subtype.none",
		axe: "card.subtype.axe",
		book: "card.subtype.book",
		bow: "card.subtype.bow",
		brush: "card.subtype.brush",
		club: "card.subtype.club",
		dagger: "card.subtype.dagger",
		fiddle: "card.subtype.fiddle",
		flail: "card.subtype.flail",
		gun: "card.subtype.gun",
		hammer: "card.subtype.hammer",
		lute: "card.subtype.lute",
		orb: "card.subtype.orb",
		pistol: "card.subtype.pistol",
		polearm: "card.subtype.polearm",
		scepter: "card.subtype.scepter",
		scroll: "card.subtype.scroll",
		scythe: "card.subtype.scythe",
		staff: "card.subtype.staff",
		sword: "card.subtype.sword",
		wrench: "card.subtype.wrench",
	},
	ally: {
		none: "card.subtype.none",
	},
	event: {
		none: "card.subtype.none",
	},
	meld: {
		none: "card.subtype.none",
	},
};
